import { useState, useEffect } from 'react';
import { Accordion } from '../../../common/SharedComponents';
import { ApplicationApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import { useSelector } from 'react-redux';
import { getLoanTypeShortName, onRowPrepared } from '../../../loans/common/LoanFunctions';
import { BfiDataGrid, Column, MasterDetail } from '../../../common/SharedComponents';
import { GridSettingType } from '@apply/constants';
import { ApplActionsButton } from '../../common/ApplicationComponents';
import { Tooltip } from 'devextreme-react/tooltip';
import { borrowerTooltipText, addressTooltipText } from '../../../common/SharedFunctions';
import PortfolioTable from './PortfolioTable';
import { onCellDblClickSummary } from '../../common/ApplicationFunctions';

const IncompleteFileTable = ({ gridStore }) => {
    const searchState = useSelector((state) => state.searchState);
    const applicationApi = new ApplicationApi.ApplicationApi(applicationInsights);
    const [dataStore, set_dataStore] = useState(gridStore?.store);

    const dataFunction = (criteria) => applicationApi.getGrid_IncompleteFile(criteria);

    useEffect(() => {
        if (gridStore) {
            gridStore.setOnLoad('id', dataFunction, searchState?.searchText?.application);
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const actionCellRender = (e) => {
        return <ApplActionsButton data={e.data} />;
    };

    const onLoanTypeCellRender = (e) => {
        return getLoanTypeShortName(e.data.loanTypeId);
    };

    const onBorrowerCellRender = (e) => {
        const targetId = `be_${e.data.id}`;
        const text = borrowerTooltipText(e.data.borrower);
        return (
            <>
                <div
                    data-tip
                    data-for={targetId}
                >
                    {e.data.borrowerEntity}
                    {e.data.propertyCount > 1 && (
                        <span>
                            <b>&nbsp;[+{e.data.propertyCount}]</b>
                        </span>
                    )}
                </div>
                <Tooltip
                    target={`[data-for="${targetId}"]`}
                    showEvent='mouseenter'
                    hideEvent='mouseleave'
                    hideOnOutsideClick={false}
                >
                    {text}
                </Tooltip>
            </>
        );
    };

    const onCityCellRender = (e) => {
        const targetId = `ac_${e.data.id}`;
        const text = addressTooltipText(e.data.address);
        return (
            <>
                <div
                    data-tip
                    data-for={targetId}
                >
                    {e.data.propertyCity}
                </div>
                {!e.data.isPortfolio && (
                    <Tooltip
                        target={`[data-for="${targetId}"]`}
                        showEvent='mouseenter'
                        hideEvent='mouseleave'
                        hideOnOutsideClick={false}
                    >
                        {text}
                    </Tooltip>
                )}
            </>
        );
    };

    const onStateCellRender = (e) => {
        const targetId = `as_${e.data.id}}`;
        const text = addressTooltipText(e.data.address);
        return (
            <>
                <div
                    data-tip
                    data-for={targetId}
                >
                    {e.data.propertyState}
                </div>
                {!e.data.isPortfolio && (
                    <Tooltip
                        target={`[data-for="${targetId}"]`}
                        showEvent='mouseenter'
                        hideEvent='mouseleave'
                        hideOnOutsideClick={false}
                    >
                        {text}
                    </Tooltip>
                )}
            </>
        );
    };

    const renderPortfolioRecords = (e) => {
        if (!e.data.isPortfolio) {
            return '';
        }
        return (
            <div style={{ padding: '5px 20px' }}>
                <PortfolioTable data={e.data.portfolio} />
            </div>
        );
    };

    return (
        <Accordion
            title='Incomplete File'
            subTitle=''
        >
            <div className='card'>
                <div className='card-section'>
                    <BfiDataGrid
                        gridType={GridSettingType.Application_IncompleteFile}
                        dataStore={dataStore}
                        applicationInsights={applicationInsights}
                        onRowPrepared={onRowPrepared}
                        onCellDblClick={onCellDblClickSummary}
                    >
                        <Column
                            dataField='borrowerEntity'
                            caption='Entity'
                            minWidth={120}
                            alignment='left'
                            cellRender={onBorrowerCellRender}
                        />
                        <Column
                            dataField='propertyCity'
                            caption='City'
                            width={100}
                            alignment='left'
                            cellRender={onCityCellRender}
                        />
                        <Column
                            dataField='propertyState'
                            caption='State'
                            width={60}
                            alignment='left'
                            cellRender={onStateCellRender}
                        />
                        <Column
                            dataField='bfiNumber'
                            caption='BFI #'
                            dataType='string'
                            width={120}
                        />
                        <Column
                            dataField='createdDate'
                            caption='Applied'
                            width={100}
                            dataType='date'
                            alignment='left'
                        />
                        <Column
                            dataField={'loanTypeId'}
                            caption='Type'
                            width={120}
                            cellRender={onLoanTypeCellRender}
                            alignment='left'
                        />
                        <Column
                            dataField='noticeSentDate'
                            caption='Notice Date'
                            dataType='date'
                            width={100}
                        />
                        <Column
                            dataField='noticeSentBy'
                            caption='Sent By'
                            dataType='string'
                            width={200}
                        />
                        <Column
                            alignment='center'
                            cellRender={actionCellRender}
                            width={50}
                            allowReordering={false}
                            allowSorting={false}
                            allowResizing={false}
                            type='actions'
                            fixed={true}
                            fixedPosition={'right'}
                        />
                        <MasterDetail
                            enabled={true}
                            render={renderPortfolioRecords}
                        />
                    </BfiDataGrid>
                </div>
            </div>
        </Accordion>
    );
};

export default IncompleteFileTable;
